import React, { useContext } from 'react'
import { AuthenticationContext } from 'app/Contexts/AuthenticationProvider'
import { ProfileSteps } from 'EstraSuppliers'
import { Steps, StepsNav } from '../StepsNav'

interface ProfileStepsNavProps {
  currentStep: ProfileSteps
}

export const ProfileStepsNav: React.FC<ProfileStepsNavProps> = ({
  currentStep,
}) => {
  const authCtx = useContext(AuthenticationContext)

  if (!authCtx) return null

  const supplier = authCtx.actor?.supplier

  // Hide first step if it's not a new supplier, but it's editing his data
  // to do that check if a pdf registry file has been uploaded,
  // it means that registration has been completed at least once
  const isRegistrationCompleted = supplier?.pdf_registry_updated_at

  const profileSteps: Partial<Record<ProfileSteps, string>> = {
    ...(!isRegistrationCompleted && { signup: 'SCELTA PASSWORD' }),
    user_data: 'DATI ANAGRAFICI',
    accounting_data: 'DATI CONTABILI',
    documents: 'FIRMA MODULI',
    thank_you: '', // No label, this step just set the stepsNav to completed
  }

  const stepsNumber = isRegistrationCompleted ? 'tre' : 'quattro'

  const title = `La procedura di attivazione del tuo profilo è \n composta da ${stepsNumber} step. Tu sei qui:`

  return (
    <StepsNav
      title={title}
      currentStep={currentStep}
      steps={profileSteps as Steps}
    ></StepsNav>
  )
}
